const _getCategoryMeta = (args, callback, instance) => {
    const [category] = args;
    const { canonical_url = '' } = category;
    const original = callback(...args);

    if (canonical_url && canonical_url.includes('http')) {
        return ({
            ...original,
            canonical_url
        });
    }

    return original;
};

export default {
    'Util/Meta/Dispatcher': {
        'member-function': {
            _getCategoryMeta
        }
    }
};
